import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/base/SEOHead';
import HomePage from './components/HomePage';

export default function Home() {
  const schemaData = [
    {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: '征途国际下载入口-官方正版游戏下载',
      description: '征途国际官方下载入口，提供最新版本安装包，支持Android、iOS及PC端一键下载。安全无病毒，快速安装，立即体验经典热血国战MMORPG征途国际正版游戏。',
      url: 'https://ztroute.github.io',
    },
    {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: '征途国际是什么类型的游戏？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '征途国际是一款经典热血国战MMORPG手游，以中国古代战国时期为背景，玩家可以选择不同职业，参与万人国战、帮派争霸、跨服战场等多种PVP玩法。',
          },
        },
        {
          '@type': 'Question',
          name: '征途国际支持哪些平台？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '征途国际全面支持Android安卓、iOS苹果以及PC电脑端三平台。您可以在本页面根据您的设备选择对应的下载入口，一键下载安装。',
          },
        },
        {
          '@type': 'Question',
          name: '游戏安装包有多大？对手机配置有什么要求？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '征途国际安装包约2.5GB，建议预留5GB以上存储空间。推荐配置：Android 8.0以上、iOS 13以上、运行内存4GB以上。',
          },
        },
        {
          '@type': 'Question',
          name: '下载安装后无法启动怎么办？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '请尝试：1.确认设备系统版本满足最低要求；2.清理手机缓存并重启设备；3.卸载后重新从官方渠道下载安装；4.如仍无法解决，请联系官方客服。',
          },
        },
      ],
    },
  ];

  return (
    <>
      <SEOHead
        title="征途国际下载入口-官方正版游戏下载 | 征途国际官方下载站"
        description="征途国际官方下载入口，提供最新版本安装包，支持Android、iOS及PC端一键下载。安全无病毒，快速安装，立即体验经典热血国战MMORPG征途国际正版游戏。"
        keywords="征途国际下载入口,征途国际下载,征途国际官方下载,征途国际安装包,征途国际手游下载,征途国际PC下载,征途国际最新版"
        canonicalUrl="https://ztroute.github.io"
        schemaData={schemaData}
      />
      <Navbar />
      <HomePage />
      <Footer />
    </>
  );
}